import { FC, useCallback, useMemo } from 'react'
import { Modal } from '../../components'
import { useTranslation } from 'react-i18next'
import { IdoorAccess, IroomsList } from '../../API/types'
import dayjs from 'dayjs'
import { DATETIME_FORMAT } from '../../API/utils'
import { useGetAccessLogById } from '../../API'
import { DataGrid, GridColDef, GridRenderCellParams, useGridApiRef } from '@mui/x-data-grid'

interface DoorAccessLogProps {
  handleClickClose: () => void
  roomsListData: IdoorAccess[]
  roomsList: IroomsList[]
  id: string
}

const DoorAccessLog: FC<DoorAccessLogProps> = ({ handleClickClose, roomsListData, roomsList, id }) => {
  const { t } = useTranslation('')
  const dataGridRef = useGridApiRef()

  const accessLog = useGetAccessLogById(id)

  const roomsData = useMemo(() => {
    return roomsListData.find((roomsData) => roomsData.id === id)
  }, [id, roomsListData])

  const handleClose = useCallback(() => {
    handleClickClose()
  }, [handleClickClose])

  const columns: GridColDef[] = [
    //{ field: 'comments', headerName: t('Vārds, telefons, kommentārs'), width: 220 },
    {
      field: 'logTime',
      headerName: t('Datums'),
      width: 130,
      renderCell: (params: GridRenderCellParams) => {
        return dayjs(params.row?.logTime).format(DATETIME_FORMAT)
      },
    },
    /*
    {
      field: 'operator',
      headerName: t('Darbība'),
      width: 130,
      renderCell: (params: GridRenderCellParams) => {
        return 'Atvēra durvis'
      },
    },
*/
    {
      field: 'passType',
      headerName: t('Paroles tips'),
      width: 130,
    },
    {
      field: 'msg',
      headerName: t(''),
      width: 230,
      renderCell: (params: GridRenderCellParams) => {
        const selectedRoomsData = roomsList.find((roomsData) => roomsData.id === params.row?.locationId)
        if (selectedRoomsData) {
          //console.log(selectedRoomsData);

          return 'Atvēra durvis " ' + selectedRoomsData.roomName + ' "'
        }

        return ''
      },
    },
  ]

  //console.log(accessLog);

  return (
    <Modal
      maxWidth={'sm'}
      isOpen={true}
      handleClose={handleClose}
      dialogTitle={'Piekļuves žurnāls'}
      closeTitle={t(`Aizvērt`)}
    >
      <div>{roomsData?.comments}</div>
      {t(`${dayjs(roomsData?.dateFrom).format(DATETIME_FORMAT)} - ${dayjs(roomsData?.dateTo).format(DATETIME_FORMAT)}`)}

      <DataGrid
        apiRef={dataGridRef}
        rows={accessLog || []}
        columns={columns}
        rowSelection={false}
        disableColumnMenu={true}
        hideFooter={true}
        autoHeight={true}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 100 },
          },
        }}
        pageSizeOptions={[50, 10]}
      />
    </Modal>
  )
}

export default DoorAccessLog
